import { ChangeDetectionStrategy, Component } from "@angular/core";
import { UntilDestroy } from "@ngneat/until-destroy";
import { localize } from "@gtmhub/localization";
import { getCurrentUserId } from "@gtmhub/users";
import { LocalizationModule } from "@webapp/localization/localization.module";
import { AssigneeActiveOkrsListComponent } from "@webapp/okrs/components/assignee-active-okrs-list/assignee-active-okrs-list.component";
import { UiCardModule } from "@webapp/ui/card/card.module";
import { BaseWidgetComponent } from "@webapp/ui/dashboard/components/base-widget.component";
import { WidgetActionsComponent } from "../widget-actions/widget-actions.component";

@UntilDestroy()
@Component({
  selector: "my-okrs-widget",
  templateUrl: "./my-okrs-widget.component.html",
  styleUrls: ["./my-okrs-widget.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [LocalizationModule, UiCardModule, AssigneeActiveOkrsListComponent, WidgetActionsComponent],
})
export class MyOkrsWidgetComponent extends BaseWidgetComponent {
  public get title(): string {
    return localize("my_okrs");
  }

  public get a11yLabel(): string {
    return "My OKRs. Owned by me and my teams.";
  }

  public get currentUserId(): string {
    return getCurrentUserId();
  }
}
